import { render, staticRenderFns } from "./ReceiverSystemEditPageDynamic.vue?vue&type=template&id=705bcf70"
import script from "./ReceiverSystemEditPageDynamic.vue?vue&type=script&lang=js"
export * from "./ReceiverSystemEditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports